export default __webpack_public_path__ + "static/Dr.-Saba-Jamal-a17d07bc26abc9f3d19ca86770f2af64.jpg";